export default {
  app: {
    privacy: {
      policy: 'politique de confidentialité',
      expansive: 'En utilisant Expansive, vous acceptez l’{action} Expansive',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Session expirée',
    sessionExpiredDescription:
      'Votre session a expiré. Veuillez vous reconnecter pour continuer à utiliser l’application.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Choisir la langue',
      chooseLanguageDescription:
        'Choisissez votre langue préférée pour l’application. Cela changera la langue de l’interface et du contenu.',
    },
    userSelection: {
      cancel: 'Annuler',
      createNewUser: 'Leur nom n’est pas listé',
      newUser: 'Nouvel utilisateur',
      selectAnExistingUser: 'Sélectionner un utilisateur existant',
      selectUserHint: 'Sélectionnez un utilisateur existant ou créez-en un nouveau pour continuer.',
      startTypingToSearch: 'Commencez à taper...',
    },
    verification: {
      codeVerification: {
        continue: 'Continuer',
        header: 'Entrez le code d’accès au site',
        invalidCode: 'Code invalide, veuillez réessayer.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Continuer sans vérifier la localisation',
        enterSiteAccessCode: "Entrez le code d'accès au site",
        locationNotEnabledOrAvailable: 'Pourquoi je vois cela ?',
        notAvailable: {
          description: "La localisation GPS n'est pas prise en charge sur cet appareil.",
          header: 'Localisation non prise en charge',
        },
        notEnabled: {
          description:
            "Les services de localisation ne sont pas activés ou l'autorisation n'a pas été accordée.",
          header: 'Localisation non activée',
        },
        notVerified: {
          description: 'Le GPS indique que vous n’êtes pas sur le site.',
          header: 'Localisation non vérifiée',
        },
        tryAgain: 'Réessayer',
        unavailable: {
          description: 'Nous n’avons pas pu vérifier votre position GPS.',
          header: 'Localisation indisponible',
        },
        unknown: {
          description: 'Nous ne pouvons pas déterminer votre position.',
          header: 'Localisation inconnue',
        },
        verified: {
          description: 'Le GPS indique que vous êtes sur le site.',
          header: 'Localisation vérifiée',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Aucun équipement trouvé',
        emptyDescription: 'Aucun équipement n’est associé à cet ordre de travail.',
        warrantyParts: 'Garantie des pièces expire',
        serialNumber: 'Numéro de série',
        none: '<aucun>',
      },
      updates: {
        emptyTitle: 'Aucune mise à jour trouvée',
        emptyDescription: 'Aucune mise à jour pour cet ordre de travail.',
        unknownUser: 'Utilisateur inconnu',
        none: 'Aucun',
        addComment: {
          buttonLabel: 'Ajouter un commentaire',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Dangers',
          no: 'Non',
          yes: 'Oui',
        },
      },
    },
    attachmentsList: {
      attachments: 'Pièces jointes',
      documents: 'Documents',
      siteDocuments: 'Documents du site',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Dangers',
        induction: 'Accueil',
        safeToProceed: 'Sûr de continuer',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: "Date d'échéance",
        activeSessions: 'Sessions actives',
        activeSessionsDescription:
          'Vous êtes déjà enregistré sur les ordres de travail suivants. Vous devez vous déconnecter de ces ordres avant de vous enregistrer sur un nouvel ordre.',
        resumeSession: 'Reprendre',
        startTime: 'Commencé à',
        unexpectedErrorTitle: 'Erreur inattendue',
        unexpectedErrorMessage:
          'Une erreur inattendue est survenue lors de la création de vos sessions. Veuillez réessayer plus tard.',
        engineerNotFound: 'Ingénieur introuvable',
        engineerNotFoundDescription:
          'L’ingénieur que vous essayez d’enregistrer n’est pas trouvé dans le système. Veuillez contacter votre administrateur.',
      },
      verification: {
        code: {
          description:
            'Pour vous enregistrer, veuillez obtenir le code à 4 chiffres auprès du responsable du site ou du contact désigné.',
        },
        geo: {
          continue: 'Continuer',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              "Veuillez obtenir le code d'accès auprès du responsable du site ou du contact désigné pour terminer votre visite.",
            checkOut: 'Départ',
            completeBeforeLeaving: 'Veuillez compléter le formulaire suivant avant de partir.',
            continue: 'Continuer',
            noResolutionSelected: 'Veuillez sélectionner une résolution avant de continuer.',
            quoteRequired: {
              hint: 'Visite terminée, devis à suivre',
              label: 'Devis requis',
            },
            returnVisitRequired: {
              hint: 'Nous reviendrons pour terminer',
              label: 'Visite de retour requise',
            },
            serviceCompleted: {
              hint: 'Aucune action supplémentaire requise',
              label: 'Service terminé',
            },
            uploadCheckout: 'Télécharger un fichier, une photo ou une vidéo',
            visitNotes: 'Notes de visite',
            workOrderResolution: 'Résolution de l’ordre de travail',
            enterNotes: 'Entrez vos notes ici...',
            errors: {
              timedOut: 'Délai dépassé, plus de 30 secondes. Veuillez réessayer.',
              closingSession: 'Erreur lors de la fermeture de la session',
            },
          },
          success: {
            description:
              'Merci d’avoir visité {site}. | {site} a encore 1 ordre de travail ouvert. | {site} a encore {count} ordres de travail ouverts.',
            endVisit: 'Fin de visite',
            header: 'Vous vous êtes déconnecté avec succès',
            viewWorkOrders: 'S’enregistrer sur un autre ordre de travail',
          },
          verification: {
            code: {
              description:
                'Pour partir, veuillez obtenir le code à 4 chiffres auprès du responsable du site ou du contact désigné.',
              continue: 'Continuer',
            },
            geo: {
              checkOut: 'Départ',
              continue: 'Continuer',
            },
          },
        },
        detail: {
          assets: 'Équipements',
          call: 'Appeler',
          checkOut: 'Départ',
          closed: 'Fermé',
          details: 'Détails',
          dueBy: "Date d'échéance",
          manageEngineers: 'Gérer les ingénieurs',
          notAvailable: 'Non disponible',
          pointOfContact: 'Point de contact',
          siteAccessTimes: "Horaires d'accès au site",
          siteAccessInstructions: "Instructions d'accès",
          siteAddress: 'Adresse du site',
          siteNotes: 'Notes du site',
          siteTelephone: 'Téléphone du site',
          siteLocation: 'Localisation du site',
          updates: 'Mises à jour',
          more: 'Plus',
          mismatchErrorTitle: 'Erreur d’ordre de travail',
          mismatchErrorMessage:
            'L’ordre de travail que vous essayez d’accéder ne correspond pas à celui sur lequel vous êtes actuellement enregistré. Veuillez vérifier votre ordre de travail et réessayer.',
          siteDocuments: 'Documents du site',
          validFrom: 'Valide à partir de',
          validUntil: 'Valide jusqu’au',
          documentName: 'Nom du document',
          documentType: 'Type de document',
          attachments: 'Fichiers de l’ordre de travail',
          download: 'Télécharger',
          workDetails: 'Détails du travail',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Ajouter un ingénieur assistant',
            assistantEngineers: 'Ingénieurs assistants',
            description:
              'Pour des raisons de sécurité, veuillez indiquer le nom de chaque ingénieur sur le site.',
            editMainEngineer: 'Modifier l’ingénieur principal',
            errors: {
              creatingEngineer: 'Erreur lors de la création de l’ingénieur',
              creatingSession: 'Erreur lors de la création de la session',
            },
            header: 'Ingénieurs sur le site',
            mainEngineer: 'Ingénieur principal',
            newAssistantEngineer: 'Entrez leur nom complet',
            next: 'Suivant',
            removeEngineer: 'Supprimer l’ingénieur',
            selectExistingAssistantEngineer: 'Commencez à taper leur nom',
          },
          index: {
            description:
              'Pour des raisons de sécurité, veuillez indiquer le nom de chaque ingénieur sur le site.',
            errorCreatingEngineer: 'Erreur lors de la création de l’ingénieur, veuillez réessayer.',
            header: 'Ingénieurs sur le site',
            hintMainEngineer: 'Entrez le nom complet de l’ingénieur principal',
            newMainEngineer: 'Nouvel ingénieur principal',
            next: 'Suivant',
            selectExistingMainEngineer: 'Sélectionner un ingénieur principal existant',
            yes: 'Oui',
            no: 'Non',
            mainEngineerLabel: 'Êtes-vous l’ingénieur principal ?',
          },
        },
        index: {
          callUsOn: 'Appelez-nous au {phoneNumber}',
          description: 'Vous ne trouvez pas ce que vous cherchez ?',
          dueBy: "Date d'échéance",
          header: 'Sélectionner un ordre de travail',
          notAvailable: 'Non disponible',
          searchWorkOrders: 'Rechercher des ordres de travail...',
        },
        manageEngineers: {
          manageEngineers: 'Gérer les ingénieurs',
          notWorking: 'Travailleurs inactifs',
          pause: 'Pause',
          resume: 'Reprendre',
          workingNow: 'Travailleurs actifs',
          startTime: 'Heure de début',
          endTime: 'Heure de fin',
          duration: 'Durée',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Retour',
            feedbackDescription:
              'Veuillez fournir un retour sur l’ordre de travail pour nous aider à améliorer nos services.',
            feedbackLabel: 'Retour',
            filesLabel: 'Pièces jointes',
            submissionLabel: 'Soumettre le retour',
          },
          hazards: {
            back: 'Retour',
            hazards: 'Dangers',
            next: 'Suivant',
            no: 'Non',
            noTasksForHazard: 'Aucune tâche à accomplir pour ce danger.',
            yes: 'Oui',
          },
          induction: {
            continue: 'Continuer',
            induction: 'Accueil',
          },
          index: {
            checkIn: 'Enregistrement',
            description:
              'Veuillez compléter l’évaluation des risques suivante pour le travail sélectionné.',
            fail: 'Échec du traitement des vérifications de début de travail.',
            haltMessage:
              'Risques potentiels détectés. Veuillez arrêter le travail, consulter les consignes de sécurité et contacter votre superviseur pour plus d’instructions.',
            header: 'Vérifications de début de travail',
            endVisit: 'Fin de visite',
            leaveFeedback: 'Laisser un retour',
          },
          safeToProceed: {
            continue: 'Continuer',
            safeToProceed: 'Sûr de continuer',
          },
        },
      },
    },
    index: {
      title: 'Bienvenue',
      description: 'Scannez le QR code à votre emplacement pour commencer.',
    },
    login: {
      errorTitle: 'Erreur inattendue',
      errorMessage: 'Une erreur inattendue est survenue. Veuillez réessayer de scanner le QR code.',
    },
    unauthenticated: {
      welcome: {
        title: 'Bienvenue à {site}',
        description:
          'Avant de pouvoir vous montrer des ordres de travail, nous devons vérifier vos informations. Cliquez sur le bouton ci-dessous pour continuer.',
        next: 'Continuer',
      },
      index: {
        errorTitle: 'Erreur inattendue',
        errorMessage:
          'Une erreur inattendue est survenue. Veuillez réessayer de scanner le QR code.',
      },
      contractor: {
        title: 'Pour qui travaillez-vous ?',
        contractor: 'Entrepreneur',
        contractorLabel: 'Commencez à taper le nom de votre entreprise',
        contractorHint: 'Vous devez saisir au moins 3 caractères pour voir les résultats',
        defaultSelectPlaceholder: '--Veuillez sélectionner--',
        next: 'Suivant',
      },
      user: {
        title: 'Qui êtes-vous ?',
        cancel: 'Annuler',
        createNewUserLabel: 'Mon nom n’est pas listé',
        existingUserLabel: 'Commencez à taper votre nom',
        existingUserHint: 'Vous devez saisir au moins 3 caractères pour voir les résultats',
        newUserLabel: 'Entrez votre nom complet',
        next: 'Suivant',
        user: 'Utilisateur',
      },
      verification: {
        methods: {
          add: {
            add: 'Ajouter une méthode de vérification',
            defaultSelectPlaceholder: '--Veuillez sélectionner--',
            emailLabel: 'E-mail',
            existingMethodWarning:
              'Vous avez déjà une demande en attente pour cette méthode de vérification en attente d’approbation par un administrateur. En ajouter une nouvelle l’écrasera.',
            method: 'Méthode',
            methodLabel: 'Méthode',
            mobileCountryHint: 'Veuillez sélectionner votre indicatif pays',
            mobileCountryLabel: 'Indicatif pays mobile',
            mobileHint: 'Veuillez entrer votre numéro de mobile',
            mobileLabel: 'Mobile',
            title: 'Ajouter une méthode de vérification',
          },
          confirm: {
            confirm: 'Confirmer',
            description: 'Veuillez confirmer votre méthode de vérification pour continuer.',
            label: 'Entrez votre code',
            resend: 'Renvoyer',
            resendPrompt: 'Vous n’avez pas reçu de code ?',
            title: 'Confirmer la méthode de vérification',
          },
          confirmed: {
            description:
              'Vous serez notifié une fois que cette méthode de vérification aura été approuvée par votre administrateur, et vous pourrez alors commencer à l’utiliser pour vérifier votre identité.',
            forceApproval:
              'Jusqu’à son approbation, vous ne pouvez pas accéder aux ordres de travail.',
            nonForceApproval:
              'En attendant, vous pouvez continuer à accéder aux ordres de travail avec un accès réduit.',
            nonForceApprovalButtonLabel: 'Continuer avec un accès réduit',
            title: 'En attente d’approbation',
          },
          addNew: 'Ajouter une nouvelle méthode de vérification',
          description:
            'Nous devons vérifier votre identité afin de vous donner un accès complet à l’ordre de travail.',
          email: 'E-mail',
          hint: 'Nous enverrons un lien à votre méthode de vérification sélectionnée qui vous donnera un accès complet à l’ordre de travail. Si vous devez modifier une méthode existante, veuillez contacter votre administrateur.',
          label: 'Sélectionnez une méthode de vérification',
          next: 'Suivant',
          pendingHint: 'En attente d’approbation de votre administrateur',
          sms: 'SMS',
          title: 'Vérification',
        },
        optional: {
          hint: 'La vérification de vos informations utilisateur vous donnera un accès complet à l’ordre de travail',
          label: 'Voulez-vous vérifier vos informations utilisateur ?',
          next: 'Suivant',
          no: 'Non',
          noHint:
            'Je ne veux pas vérifier mes informations utilisateur et continuer avec un accès réduit à l’ordre de travail',
          title: 'Vérification',
          yes: 'Oui',
          yesHint:
            'Je veux vérifier mes informations utilisateur et obtenir un accès complet à l’ordre de travail',
        },
        sent: {
          description:
            'Un lien de connexion a été envoyé à {identifier}. Veuillez cliquer sur le lien pour terminer votre connexion.',
          title: 'Lien de connexion envoyé',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Hier',
      today: 'Aujourd’hui',
      days: {
        monday: 'Lundi',
        tuesday: 'Mardi',
        wednesday: 'Mercredi',
        thursday: 'Jeudi',
        friday: 'Vendredi',
        saturday: 'Samedi',
        sunday: 'Dimanche',
      },
      months: {
        january: 'Janvier',
        february: 'Février',
        march: 'Mars',
        april: 'Avril',
        may: 'Mai',
        june: 'Juin',
        july: 'Juillet',
        august: 'Août',
        september: 'Septembre',
        october: 'Octobre',
        november: 'Novembre',
        december: 'Décembre',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Une erreur est survenue',
      message: 'Veuillez réessayer de scanner le QR code.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Utilisateur inconnu',
      },
      none: 'Aucun',
      types: {
        stateTransition: 'Statut modifié',
        contractorAssigned: 'Entrepreneur assigné',
        engineerAssigned: 'Ingénieur assigné',
        serviceAssigned: 'Service assigné',
        priorityChanged: 'Priorité modifiée',
        actionableDateChanged: 'Date d’action modifiée',
        dueDateChanged: 'Date d’échéance modifiée',
        etaDateChanged: 'Date d’arrivée estimée modifiée',
        spendLimitApproved: 'Plafond de dépenses approuvé',
        spendLimitCancelled: 'Demande de plafond de dépenses annulée',
        spendLimitRejected: 'Plafond de dépenses refusé',
        spendLimitRequested: 'Plafond de dépenses demandé',
        jobSheetUploaded: 'Feuille de travail téléchargée',
        slaAlertSent: 'Alerte SLA pour dépassement du temps d’intervention',
        issuedWorkPermit: 'Permis de travail délivré',
        requestForServiceSent: 'Demande de service envoyée',
        comment: 'Commentaire ajouté',
        unknown: 'Événement inconnu',
      },
      labels: {
        actionableDate: 'Date d’action',
        comment: 'Commentaire',
        file: 'Fichier',
        contractor: 'Entrepreneur',
        dueDate: 'Date d’échéance',
        etaDate: 'Date d’arrivée estimée',
        engineer: 'Ingénieur',
        priority: 'Priorité',
        requestForService: 'Demande de service',
        service: 'Service',
        spendLimit: 'Plafond de dépenses',
        status: 'Statut',
        workPermit: 'Permis de travail',
      },
    },
  },
}
